// extracted by mini-css-extract-plugin
export default {"goBack":"goback_goBack__GyjYq","hello":"goback_hello__aakw6","goback":"goback_goback__Xe22s"};